import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

const TextField = ({
  className, source, record, ...rest
}) => (
  <Typography
    component="span"
    body1="body1"
    className={className}
    {...sanitizeRestProps(rest)}
  >
    {`${record[source]} %`}
  </Typography>
);

TextField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
};

const TextLabelWithPercantage = pure(TextField);

TextLabelWithPercantage.defaultProps = {
  addLabel: true,
};

export default TextLabelWithPercantage;



// WEBPACK FOOTER //
// ./src/components/TextFieldWithPercantage.js